import React from 'react';
import { taskKind, TASK_KINDS } from '../utils/taskKind';

// Small one-line colored label for a task's type (Transaction, Pipeline, Lead follow-up, Manual).
export default function TaskKindLabel({ task, kind, style }) {
  const k = TASK_KINDS[kind || taskKind(task)];
  return (
    <span
      data-testid="task-kind"
      style={{
        display: 'inline-block', whiteSpace: 'nowrap', flex: '0 0 auto', verticalAlign: 'middle',
        fontSize: 11, fontWeight: 700, lineHeight: '16px', letterSpacing: '0.2px',
        padding: '1px 7px', borderRadius: 999, background: k.bg, color: k.fg, border: `1px solid ${k.border}`,
        ...style,
      }}
    >
      {k.label}
    </span>
  );
}
